"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitData = exports.WaitConditions = void 0;
class WaitConditions {
    constructor() {
        this.m_dict = {};
    }
    set(condition) {
        this.m_dict[condition] = true;
    }
    reset(condition) {
        delete this.m_dict[condition];
    }
    get(condition) {
        if (this.m_dict[condition] == undefined)
            return false;
        return this.m_dict[condition];
    }
}
exports.WaitConditions = WaitConditions;
class WaitData {
    constructor() {
        this.m_dict = {};
    }
    set(dataType, data) {
        this.m_dict[dataType] = data;
    }
    reset(dataType) {
        delete this.m_dict[dataType];
    }
    get(dataType) {
        return this.m_dict[dataType];
    }
}
exports.WaitData = WaitData;
